module.exports = __webpack_public_path__ + "media/application/images/ui/sign-up-lightbox-85e7ac08bd4d678333f405e6c70a0db0.jpg";